import { Card } from 'antd';
import type { ReactNode } from 'react';
import styles from '../Reports.module.scss';

export type StatTone = 'primary' | 'accent' | 'success' | 'warning' | 'danger';

interface StatCardProps {
  label: string;
  value: string;
  hint?: string;
  icon: ReactNode;
  tone?: StatTone;
  index?: number;
}

export function StatCard({
  label,
  value,
  hint,
  icon,
  tone = 'primary',
  index = 0,
}: StatCardProps) {
  return (
    <Card
      className={`${styles.statCard} ${styles[tone]}`}
      bordered={false}
      style={{ animationDelay: `${index * 0.07}s` }}
    >
      <div className={styles.statCardInner}>
        <div className={styles.statIcon}>{icon}</div>
        <div className={styles.statBody}>
          <span className={styles.statLabel}>{label}</span>
          <span className={styles.statValue}>{value}</span>
          {hint ? <span className={styles.statHint}>{hint}</span> : null}
        </div>
      </div>
    </Card>
  );
}
